// extracted by mini-css-extract-plugin
export var bgLoading = "index-module--bg-loading--50272";
export var borderLoading = "index-module--border-loading--ed482";
export var breakBorderLoading = "index-module--break-border-loading--f2c0c";
export var gradient = "index-module--gradient--e34f1";